import 'scss/solutions/raibooSolution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'
import { config } from 'config'
import * as userApi from 'js/api/user'
import { showLoginModal } from 'js/libs/utils-login'

$(function () {
  $('.join-now').click(function () {
    var $this = $(this)
    var href = $this.data('href')
    userApi.checkLogin().then(result => {
      if (result.code === 80000) {
        showLoginModal()
      } else {
        window.open(href)
      }
    })
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/raibooSolution.js